import { ROUTES } from "@/routes/routes"

/**
 * Built from the ROUTES patterns rather than hardcoded strings, so a route and
 * its link builder cannot drift apart. Values are URL-encoded: an id containing
 * `/`, `?` or `#` would otherwise silently produce a different path.
 */
function build(pattern: string, params: Record<string, string>): string {
  let path = pattern
  for (const [key, value] of Object.entries(params)) {
    path = path.replace(`:${key}`, encodeURIComponent(value))
  }
  return path
}

export function customerDetailPath(customerId: string): string {
  return build(ROUTES.CUSTOMER_DETAILS, { customerId })
}

/** The link a facilitator shares with the room. The session id IS the link. */
export function joinPath(sessionId: string): string {
  return build(ROUTES.JOIN, { sessionId })
}

/** Absolute URL for the same, for copy-to-clipboard or a QR code. */
export function joinUrl(sessionId: string, origin: string = window.location.origin): string {
  return `${origin}${joinPath(sessionId)}`
}

export function sessionPath(sessionId: string): string {
  return build(ROUTES.SESSION, { sessionId })
}

/** The debrief on its own, outside the session it came from. */
export function reportPath(sessionId: string): string {
  return build(ROUTES.REPORT, { sessionId })
}
